import md5 from 'js-md5'

export default async function calculateFileMD5(file) {
  const arrayBuffer = await file.arrayBuffer()
  return md5.base64(new Uint8Array(arrayBuffer))
}
